export default "__VITE_ASSET__DGunHcyN__"